import { connect } from 'react-redux';
import { Locales } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { withChartLayout } from 'components/common';
import NeurologicalEvaluation from 'components/features/chart/special-charts/neurological-evaluation/NeurologicalEvaluation';

const NeurologicalEvaluationContent = withChartLayout('Neurological Evaluation')(NeurologicalEvaluation);

export interface NeurologicalEvaluationPageProps {
  isSimulationEHREnabled: boolean;
  locale: Locales;
}

export const BaseNeurologicalEvaluationPage = ({ isSimulationEHREnabled, locale }: NeurologicalEvaluationPageProps) =>
  isSimulationEHREnabled && locale !== Locales.EN_AU ? <NeurologicalEvaluationContent /> : null;

const mapStateToProps = (state) => ({
  isSimulationEHREnabled: appSelectors.getIsSimulationEHREnabled(state),
  locale: appSelectors.getLocale(state)
});

export default connect(mapStateToProps)(BaseNeurologicalEvaluationPage);
